import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GoldForm from '../../components/forms/GoldForm';
import { getListeFournisseur } from '../../actions';

const GoldFormContainer = ({ listeFournisseur = [], getListeFournisseur: loadFournisseurs }) => {
  useEffect(() => {
    if (!listeFournisseur || !listeFournisseur.length) loadFournisseurs();
  }, [listeFournisseur, loadFournisseurs]);

  // filtrer uniquement type_four === 998 et actif === 1
  const fournisseurs = (listeFournisseur || []).filter(f => Number(f.type_four) === 998 && Number(f.actif) === 1).map(f => ({ ...f, label: f.raison_soc || f.label || `${f.id}` }));

  const handleSubmit = () => {};

  return <GoldForm fournisseurs={fournisseurs} onSubmit={handleSubmit} />;
};

GoldFormContainer.propTypes = {
  listeFournisseur: PropTypes.array,
  getListeFournisseur: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  listeFournisseur: state.generalData && state.generalData.listeFournisseur
});

const mapDispatchToProps = { getListeFournisseur };

export default connect(mapStateToProps, mapDispatchToProps)(GoldFormContainer);
